/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_4Inputs */

const en_fc_vs_pr_wins_4 = /** @type {(inputs: Fc_Vs_Pr_Wins_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huge ecosystem of plugins, templates and tutorials.`)
};

/**
* | output |
* | --- |
* | "Huge ecosystem of plugins, templates and tutorials." |
*
* @param {Fc_Vs_Pr_Wins_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_4 = /** @type {((inputs?: Fc_Vs_Pr_Wins_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_4(inputs)
});
export { fc_vs_pr_wins_4 as "fc.vs.pr_wins.4" }